import { render, staticRenderFns } from "./b-form-input-lang.vue?vue&type=template&id=b5cb2146&scoped=true&"
import script from "./b-form-input-lang.vue?vue&type=script&lang=js&"
export * from "./b-form-input-lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb2146",
  null
  
)

export default component.exports